// import LanguageService from "./service/LanguageService";
export default {
  items: [
    {
      name: "Doanh nghiệp đăng ký Chương trình Kích cầu du lịch",
      url: "/admin/DangKyChuongTrinhKichCau",
      icon: "fas fa-registered",
      meta: {
        allowAccess: ["TrangVangCompanyManager", "VNATAdmin", "Officer"],
        page: "admin",
      },
      children: [
        {
          name: "Doanh nghiệp chờ duyệt",
          url: "/admin/DangKyChuongTrinhKichCau/pending",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["TrangVangCompanyManager", "VNATAdmin", "Officer"],
            page: "admin",
          },
        },
        {
          name: "Doanh nghiệp đã duyệt",
          url: "/admin/DangKyChuongTrinhKichCau/approved",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["TrangVangCompanyManager", "VNATAdmin", "Officer"],
            page: "admin",
          },
        },
      ],
    },
    {
      name: "Đánh giá mức độ chuyển đổi số",
      url: "/admin/GoToClient",
      icon: "fas fa-heart-rate",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
    },
    {
      name: "Báo cáo thống kê",
      url: "/admin/BaoCaoThongKe",
      icon: "fas fa-print",
      meta: {
        allowAccess: ["SafePlace", "TourAgent"],
        page: "admin",
      },
    },
    {
      name: "Trở thành điểm chấp nhận thanh toán thẻ",
      url: "/admin/SignUpBankAccount",
      icon: "fas fa-money-check-alt",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
    },
    {
      name: "Khách hàng thân thiết",
      url: "/admin/SignUpBankAccount-2",
      icon: "fas fa-money-check-alt",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
    },
    {
      name: "Giới thiệu",
      url: "/admin/GioiThieu/list",
      icon: "fas fa-door-open",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    // {
    //   name: "Dữ liệu an toàn hàng ngày",
    //   url: "/admin/DuLieuAnToanHangNgay",
    //   icon: "icon-calendar",
    //   meta: {
    //     allowAccess: ["SafePlace"],
    //     page: "admin"
    //   }
    // },
    {
      name: "Phản ánh",
      code: "PhanHoi",
      url: "/admin/PhanHoi/list",
      icon: "fas fa-comments",
      meta: {
        allowAccess: [
          "VNATAdmin",
          "Admin",
          "Officer",
          "SafePlace",
          "TourAgent",
          "TourAgent_Pending",
          "TrangVangContentManager",
        ],
        page: "admin",
      },
      badge: {
        variant: "danger",
        text: "0",
      },
    },
    {
      name: "Check-in điểm đến",
      url: "/admin/CheckinDDAT/list",
      icon: "fa fa-map-marker",
      meta: {
        allowAccess: ["Admin", "Officer", "SafePlace"],
        page: "admin",
      },
    },
    {
      name: "QR Code",
      url: "/admin/QRCode/infomation",
      icon: "fas fa-qrcode",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
    },
    // {
    //   name: "Đánh giá an toàn hằng ngày",
    //   url: "/admin/DanhGiaAnToanHangNgay/day",
    //   icon: "fas fa-calendar-check",
    //   meta: {
    //     allowAccess: ["SafePlace"],
    //     page: "admin"
    //   }
    // },
    {
      name: "Nhà cung cấp dịch vụ",
      url: "/admin/NhaCungCapDichVu",
      icon: "fas fa-building",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
      children: [
        // {
        //     name: "Dịch vụ điểm đến",
        //     url: "/admin/NhaCungCapDichVu/DichVuDiemDen",
        //     icon: "fas fa-map-marked-alt",
        //     meta: {
        //         allowAccess: ["Admin", "Officer"],
        //         page: "admin"
        //     },
        //     children: [{
        //             name: "Thông tin đơn vị đã duyệt",
        //             url: "/admin/NhaCungCapDichVu/DichVuDiemDen/list",
        //             icon: "fa fa-caret-right",
        //             meta: {
        //                 allowAccess: ["Admin", "Officer"],
        //                 page: "admin"
        //             }
        //         },
        //         {
        //             name: "Thông tin đơn vị chờ duyệt",
        //             code: "DichVuDiemDen",
        //             url: "/admin/NhaCungCapDichVu/DichVuDiemDen/history",
        //             icon: "fa fa-caret-right",
        //             meta: {
        //                 allowAccess: ["Admin", "Officer"],
        //                 page: "admin"
        //             },
        //             badge: {
        //                 variant: "danger",
        //                 text: "0"
        //             },
        //         },
        //     ]
        // },
        {
          name: "Công ty lữ hành",
          url: "/admin/NhaCungCapDichVu/CongTyLuHanh/list",
          icon: "fas fa-route",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
        },
        {
          name: "Lưu trú",
          url: "/admin/NhaCungCapDichVu/DichVuLuuTru",
          icon: "fas fa-hotel",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Thông tin đơn vị đã duyệt",
              url: "/admin/NhaCungCapDichVu/DichVuLuuTru/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Thông tin đơn vị chờ duyệt",
              code: "DichVuLuuTru",
              url: "/admin/NhaCungCapDichVu/DichVuLuuTru/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Ẩm thực - Nhà hàng",
          url: "/admin/NhaCungCapDichVu/DichVuAmThuc",
          icon: "fas fa-utensils",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Thông tin đơn vị đã duyệt",
              url: "/admin/NhaCungCapDichVu/DichVuAmThuc/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Thông tin đơn vị chờ duyệt",
              code: "DichVuAmThuc",
              url: "/admin/NhaCungCapDichVu/DichVuAmThuc/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Giải trí",
          url: "/admin/NhaCungCapDichVu/DichVuGiaiTri",
          icon: "fas fa-gamepad",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Thông tin đơn vị đã duyệt",
              url: "/admin/NhaCungCapDichVu/DichVuGiaiTri/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Thông tin đơn vị chờ duyệt",
              code: "DichVuGiaiTri",
              url: "/admin/NhaCungCapDichVu/DichVuGiaiTri/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Vé điện tử",
          url: "/admin/NhaCungCapDichVu/DichVuVeDienTu",
          icon: "fas fa-ticket-alt",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Thông tin đơn vị đã duyệt",
              url: "/admin/NhaCungCapDichVu/DichVuVeDienTu/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Thông tin đơn vị chờ duyệt",
              code: "DichVuVeDienTu",
              url: "/admin/NhaCungCapDichVu/DichVuVeDienTu/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Vận tải khách",
          url: "/admin/NhaCungCapDichVu/DichVuVanTaiKhach",
          icon: "fas fa-bus-alt",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Thông tin đơn vị đã duyệt",
              url: "/admin/NhaCungCapDichVu/DichVuVanTaiKhach/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Thông tin đơn vị chờ duyệt",
              code: "DichVuVanTaiKhach",
              url: "/admin/NhaCungCapDichVu/DichVuVanTaiKhach/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
      ],
    },
    {
      name: "Bài đăng dịch vụ",
      url: "/admin/BaiDangDichVu",
      icon: "fab fa-usps",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
      children: [
        // {
        //     name: "Điểm đến",
        //     url: "/admin/BaiDangDichVu/DiemDen",
        //     icon: "fas fa-location",
        //     meta: {
        //         allowAccess: ["Admin", "Officer"],
        //         page: "admin"
        //     },
        //     children: [{
        //             name: "Bài đăng đã duyệt",
        //             url: "/admin/BaiDangDichVu/DiemDen/list",
        //             icon: "fa fa-caret-right",
        //             meta: {
        //                 allowAccess: ["Admin", "Officer"],
        //                 page: "admin"
        //             }
        //         },
        //         {
        //             name: "Bài đăng chờ duyệt",
        //             code: "DiemDen",
        //             url: "/admin/BaiDangDichVu/DiemDen/history",
        //             icon: "fa fa-caret-right",
        //             meta: {
        //                 allowAccess: ["Admin", "Officer"],
        //                 page: "admin"
        //             },
        //             badge: {
        //                 variant: "danger",
        //                 text: "0"
        //             },
        //         },
        //     ]
        // },
        {
          name: "Tour du lịch",
          url: "/admin/BaiDangDichVu/TourDuLich",
          icon: "fas fa-car",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/TourDuLich/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "TourDuLich",
              url: "/admin/BaiDangDichVu/TourDuLich/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Lưu trú",
          url: "/admin/BaiDangDichVu/LuuTru",
          icon: "fas fa-home",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/LuuTru/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "LuuTru",
              url: "/admin/BaiDangDichVu/LuuTru/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Ẩm thực",
          url: "/admin/BaiDangDichVu/AmThuc",
          icon: "fas fa-hamburger",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/AmThuc/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "AmThuc",
              url: "/admin/BaiDangDichVu/AmThuc/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Giải trí",
          url: "/admin/BaiDangDichVu/GiaiTri",
          icon: "fab fa-playstation",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/GiaiTri/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "GiaiTri",
              url: "/admin/BaiDangDichVu/GiaiTri/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Vé điện tử",
          url: "/admin/BaiDangDichVu/VeDienTu",
          icon: "fas fa-ticket-alt",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/VeDienTu/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "VeNgheThuatBieuDien",
              url: "/admin/BaiDangDichVu/VeDienTu/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
        {
          name: "Vận tải khách",
          url: "/admin/BaiDangDichVu/VanTaiKhach",
          icon: "fas fa-bus",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          children: [
            {
              name: "Bài đăng đã duyệt",
              url: "/admin/BaiDangDichVu/VanTaiKhach/list",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              name: "Bài đăng chờ duyệt",
              code: "VanTaiKhach",
              url: "/admin/BaiDangDichVu/VanTaiKhach/history",
              icon: "fa fa-caret-right",
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
              badge: {
                variant: "danger",
                text: "0",
              },
            },
          ],
        },
      ],
    },
    // {
    //     name: "Điểm đến",
    //     url: "/admin/BaiDangDichVu/DiemDen",
    //     icon: "fas fa-location",
    //     meta: {
    //         allowAccess: ["SafePlace"],
    //         page: "admin"
    //     },
    //     children: [{
    //             name: "Bài đăng đã duyệt",
    //             url: "/admin/BaiDangDichVu/DiemDen/list",
    //             icon: "fa fa-caret-right",
    //             meta: {
    //                 allowAccess: ["SafePlace"],
    //                 page: "admin"
    //             }
    //         },
    //         {
    //             name: "Bài đăng chờ duyệt",
    //             code: "DiemDenSafePlace",
    //             url: "/admin/BaiDangDichVu/DiemDen/history",
    //             icon: "fa fa-caret-right",
    //             meta: {
    //                 allowAccess: ["SafePlace"],
    //                 page: "admin"
    //             },
    //             badge: {
    //                 variant: "danger",
    //                 text: "0"
    //             },
    //         },
    //     ]
    // },
    {
      name: "Danh sách Tour",
      url: "/admin/Tour/list",
      icon: "icon-plane",
      meta: {
        allowAccess: ["Admin", "TourAgent"],
        page: "admin",
      },
    },
    {
      name: "Phiếu điều Tour",
      url: "/admin/PhieuDieuTour/list",
      icon: "icon-calendar",
      meta: {
        allowAccess: ["Admin", "TourAgent", "TourGuide"],
        page: "admin",
      },
    },
    {
      name: "Tour du lịch",
      url: "/admin/BaiDangDichVu/TourDuLich",
      icon: "fas fa-car",
      meta: {
        allowAccess: ["TourAgent", "TourAgent_Pending"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/TourDuLich/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["TourAgent", "TourAgent_Pending"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "TourDuLich",
          url: "/admin/BaiDangDichVu/TourDuLich/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["TourAgent", "TourAgent_Pending"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Bài đăng lưu trú",
      url: "/admin/BaiDangDichVu/LuuTru",
      icon: "fas fa-home",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/LuuTru/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "LuuTruSafePlace",
          url: "/admin/BaiDangDichVu/LuuTru/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Bài đăng ẩm thực",
      url: "/admin/BaiDangDichVu/AmThuc",
      icon: "fas fa-hamburger",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/AmThuc/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "AmThucSafePlace",
          url: "/admin/BaiDangDichVu/AmThuc/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Bài đăng lĩnh vực giải trí",
      url: "/admin/BaiDangDichVu/GiaiTri",
      icon: "fab fa-playstation",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/GiaiTri/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "GiaiTriSafePlace",
          url: "/admin/BaiDangDichVu/GiaiTri/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Bài đăng quảng bá",
      url: "/admin/BaiDangDichVu/VeDienTu",
      icon: "fas fa-ticket-alt",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/VeDienTu/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "VeNgheThuatBieuDienSafePlace",
          url: "/admin/BaiDangDichVu/VeDienTu/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Bài đăng vận tải khách",
      url: "/admin/BaiDangDichVu/VanTaiKhach",
      icon: "fas fa-bus",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Bài đăng đã duyệt",
          url: "/admin/BaiDangDichVu/VanTaiKhach/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Bài đăng chờ duyệt",
          code: "VanTaiKhachSafePlace",
          url: "/admin/BaiDangDichVu/VanTaiKhach/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Vé máy bay",
      url: "/admin/VeMayBay/list",
      icon: "fas fa-fighter-jet",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Vé giao thông",
      url: "/admin/VeGiaoThong/list",
      icon: "fas fa-bus",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Đơn vị cung cấp",
      url: "/admin/ThongTinDDAT",
      icon: "fas fa-flag-checkered",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
      children: [
        {
          name: "Thông tin đơn vị",
          url: "/admin/ThongTinDDAT/detail",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          name: "Cập nhật thông tin đơn vị",
          url:
            "/admin/ThongTinDDAT/update/" +
            window.localStorage.getItem("tv_don_vi_cung_caps"),
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
      ],
    },
    {
      name: "Hướng dẫn viên",
      url: "/admin/HuongDanVienDaDan/list",
      icon: "icon-people",
      meta: {
        allowAccess: ["TourAgent"],
        page: "admin",
      },
    },
    // tạm ẩn menu này vì trên con thật chưa có
    // {
    //   name: "Quản lý văn bản tour",
    //   url: "/admin/QuanLyVanBan",
    //   icon: "icon-docs",
    //   meta: {
    //     allowAccess: ["TourAgent"],
    //     page: "admin",
    //   },
    //   children: [
    //     {
    //       name: "Thêm mới văn bản",
    //       url: "/admin/QuanLyVanBan/create",
    //       icon: "fa fa-caret-right",
    //       meta: {
    //         allowAccess: ["TourAgent"],
    //         page: "admin",
    //       },
    //     },
    //     {
    //       name: "Văn bản đã tạo",
    //       url: "/admin/QuanLyVanBan/list",
    //       icon: "fa fa-caret-right",
    //       meta: {
    //         allowAccess: ["TourAgent"],
    //         page: "admin",
    //       },
    //     },
    //   ],
    // },
    {
      name: "Công ty lữ hành",
      url: "/admin/ThongTinCongTyLuHanh/detail",
      icon: "fab fa-canadian-maple-leaf",
      meta: {
        allowAccess: ["TourAgent", "TourAgent_Pending"],
        page: "admin",
      },
    },
    {
      name: "Quảng cáo",
      url: "/admin/QuangCao",
      icon: "fab fa-adversal",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
      children: [
        {
          name: "Quảng cáo đã duyệt",
          url: "/admin/QuangCao/list",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
        },
        {
          name: "Quảng cáo chờ duyệt",
          code: "QuangCao",
          url: "/admin/QuangCao/history",
          icon: "fa fa-caret-right",
          meta: {
            allowAccess: ["Admin", "Officer"],
            page: "admin",
          },
          badge: {
            variant: "danger",
            text: "0",
          },
        },
      ],
    },
    {
      name: "Quản lý Banner",
      url: "/admin/QuanLyBanner/list",
      icon: "fas fa-image",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Người dùng",
      url: "/admin/NguoiDung/list",
      icon: "fas fa-users",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Khách du lịch",
      url: "/admin/KhachDuLich/list",
      icon: "fas fa-hiking",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Đánh giá",
      url: "/admin/DanhGia/list",
      icon: "fas fa-star",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Liên hệ",
      url: "/admin/LienHe/list",
      icon: "fal fa-id-card",
      meta: {
        allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
        page: "admin",
      },
    },
    {
      name: "Điểm đến",
      url: "/admin/BaiDangDiemDen/list",
      icon: "fas fa-map-marked-alt",
      meta: {
        allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
        page: "admin",
      },
    },
    {
      name: "Tin tức",
      url: "/admin/TinTuc/list",
      icon: "fal fa-newspaper",
      meta: {
        allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
        page: "admin",
      },
    },
    {
      name: "Nguồn tin tức",
      url: "/admin/NguonTinTuc/list",
      icon: "fab fa-sourcetree",
      meta: {
        allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
        page: "admin",
      },
    },
    {
      name: "Bảng giá quảng cáo",
      url: "/admin/BangGiaQuangCao/list",
      icon: "fas fa-money-bill-wave",
      meta: {
        allowAccess: ["Admin", "Officer"],
        page: "admin",
      },
    },
    {
      name: "Nền tảng dịch vụ",
      url: "/admin/NenTangDichVu/list",
      icon: "fab fa-aws",
      meta: {
        allowAccess: ["Officer"],
        page: "admin",
      },
    },
    {
      name: "Đánh giá",
      url: "/admin/DanhGia/list",
      icon: "icon-star",
      meta: {
        allowAccess: ["TourAgent"],
        page: "admin",
      },
    },
    {
      name: "Chính sách và quyền lợi",
      url: "/admin/ChinhSachVaQuyenLoi/infomation",
      icon: "fas fa-book",
      meta: {
        allowAccess: ["TourAgent", "SafePlace", "TourAgent_Pending"],
        page: "admin",
      },
    },

    // tasks: 38443 bỏ menu
    {
      name: "Quản lý phòng",
      url: "/admin/RoomManager",
      icon: "fas fa-hotel",
      meta: {
        allowAccess: [
      "BuiltinAdmin",
      "Admin",
      "Officer",
      "SafePlace",
      "TourGuide",
      "Destination",
      "Ticket",
      "TrangVangContentManager",
      "VNATAdmin",
    ],
        page: "admin",
      },
    },
    // {
    //     name: "Quản lý bán hàng",
    //     url: "/admin/SalesManager",
    //     icon: "fas fa-usd-square",
    //     meta: {
    //         allowAccess: ["SafePlace"],
    //         page: "admin"
    //     },
    // },
    {
      name: "Quản lý thuyết minh đa phương tiện",
      url: "/admin/AutomaticCommentary/list",
      icon: "fas fa-headset",
      meta: {
        allowAccess: ["SafePlace"],
        page: "admin",
      },
    },
    {
      name: "Thông báo",
      url: "/admin/ThongBao/list",
      icon: "icon-bell",
      meta: {
        allowAccess: ["TourAgent"],
        page: "admin",
      },
    },
  ],
};
